import React from 'react';

interface HamburgerIconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

const HamburgerIcon: React.FC<HamburgerIconProps> = ({
  width = 24,
  height = 24,
  className = '',
  color = '#333',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M7.94971 11.9497H39.9497" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.94971 23.9497H39.9497" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.94971 35.9497H39.9497" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default HamburgerIcon;
